<template>
  <Message
    :severity="severity"
    :closable="closeable"
    >
    <section class="flex flex-row items-start justify-start gap-2">
      <span class="material-symbols-rounded text-xl" style="margin-top: 2px">{{ icon }}</span>
      <div class="flex flex-col gap-1">
        <span v-if="title" class="font-semibold">{{ title }}</span>
        <slot name="default">
          {{ text }}
        </slot>
      </div>
    </section>
  </Message>
</template>

<script setup lang="ts">
import { Severity } from '../types'
import Message from 'primevue/message'
import type { PropType } from 'vue'

defineProps({
  title: {
    type: String,
    default: undefined
  },
  text: {
    type: String,
    default: undefined
  },
  severity: {
    type: String as PropType<Severity>,
    default: Severity.INFO
  },
  icon: {
    type: String as PropType<string>,
    default: undefined
  },
  closeable: {
    type: Boolean as PropType<boolean>,
    default: false
  }
});
</script>

<style scoped>

</style>
